import { ArticleModel } from './article.model';
import { PriceListModel } from './price-list.model';
export class PriceListDetailModel {
  priceListDetailId: number = 0;
  priceListId: number = 0;
  priceList: PriceListModel = new PriceListModel();
  article: ArticleModel = new ArticleModel();
  articleId: number = 0;
  baseUnitValue: number = 0;
  rateDiscount: number = 0;
  clientUnitValue: number = 0;
  swManual: boolean = false;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  replicateInOtherlist: boolean = false;
}